/**
 * Phase 4g.A (Feb 2026) — Hook für Dashboard Live-KPIs.
 *
 * Holt einmalig nach Mount alle KPIs in einem HTTP-Call und liefert sie
 * konsistent an alle Quick-Action-Tooltips. Aktualisiert sich automatisch:
 *   - alle 60 s im Hintergrund
 *   - bei `visibilitychange` zurück auf Tab (z.B. nach Lock-Screen)
 *
 * Verwendung:
 *   const kpis = useDashboardKpis(user);
 *   <span>{kpis?.workshop?.open_today} offen heute</span>
 */
import { useEffect, useState, useRef } from "react";
import api from "../lib/api";

const REFRESH_INTERVAL_MS = 60_000;

export default function useDashboardKpis(user) {
    const [kpis, setKpis] = useState(null);
    const isLeader = user?.role === "zweiradverkaeufer" &&
        ["filialleiter", "verkaufsleiter"].includes(user?.employee_function);
    const enabled = user?.role === "b2b" || user?.role === "admin" || isLeader;
    const timerRef = useRef(null);

    useEffect(() => {
        if (!enabled) return;
        let cancelled = false;

        const load = async () => {
            try {
                const r = await api.get("/dealer/dashboard-kpis");
                if (!cancelled) setKpis(r.data);
            } catch {
                /* silent — tooltip falls back to "—" */
            }
        };

        load();
        timerRef.current = setInterval(load, REFRESH_INTERVAL_MS);
        const onVis = () => { if (document.visibilityState === "visible") load(); };
        document.addEventListener("visibilitychange", onVis);

        return () => {
            cancelled = true;
            if (timerRef.current) clearInterval(timerRef.current);
            document.removeEventListener("visibilitychange", onVis);
        };
    }, [enabled]);

    return kpis;
}
